
import {
  Vue, Component,
} from 'vue-property-decorator';
import { Destination } from '@/features/dashboard/types';
import ProgressItem from '@/features/dashboard/components/widgets/topChannels/ProgressItem.vue';
import LabelsList, { LabelItemType } from '@/features/dashboard/components/widgets/LabelsList.vue';
import NoContent from '@/features/dashboard/components/widgets/NoContent.vue';

interface ChartDataType {
  labels: string[],
  datasets: [
    {
      backgroundColor: string[] | string,
      data: number[],
      borderWidth: number,
    },
  ],
}

@Component({
  components: {
    ProgressItem,
    LabelsList,
    NoContent,
  },
})
export default class Content extends Vue {
  private colors: Array<string> = [
    '#623ec7', '#ffa43c', '#cb0f51', '#e1e1e1', '#2bc5cb', '#9D640F',
    '#81CB1D', '#48DD82', '#06B5D3', '#4C7B10', '#3A84F5', '#A259F6',
  ];

  private showCalendar = false;

  private customPeriod: Array<string> = [];

  private chartKey = 'topDestinationsChartKey';

  private noDataColor = '#e6e6eb';

  get destinations(): Array<Destination> {
    return this.$store.getters.getTopDestinations;
  }

  get hasData(): boolean {
    return this.destinations && this.destinations.length !== 0;
  }

  get labels(): Array<string> {
    return this.destinations.map((el: Destination) => el.countryName);
  }

  get qty(): Array<number> {
    return this.destinations.map((el: Destination) => el.percentage);
  }

  get topDestination(): string {
    const max = this.destinations.reduce((a, b) => {
      if (a.countryCode === 'ZZ') return b;
      if (b.countryCode === 'ZZ') return a;

      const output = a.percentage > b.percentage ? a : b;
      return output;
    });

    return max.countryCode;
  }

  get chartData(): ChartDataType {
    // should rerender chart when data is loaded
    this.chartKey = `${this.chartKey}-${Date.now()}`;

    return {
      labels: this.labels,
      datasets: [
        {
          backgroundColor: this.hasData ? this.colors : this.noDataColor,
          data: this.hasData ? this.qty : [100],
          borderWidth: 0,
        },
      ],
    };
  }

  get labelsData(): Array<LabelItemType> {
    return Object.entries(this.destinations).map((el): LabelItemType => {
      const val = el[1];
      return {
        name: val.countryName,
        qty: val.percentage,
      };
    });
  }

  get totalQty(): string {
    return this.hasData ? this.topDestination.toUpperCase() : 'N/A';
  }
}
